import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ca81913"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "desc" }
const _hoisted_4 = {
  inset: "",
  class: "inputGroup"
}
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "cell" }
const _hoisted_7 = {
  inset: "",
  class: "inputGroup"
}
const _hoisted_8 = { class: "label" }
const _hoisted_9 = { class: "cell" }
const _hoisted_10 = {
  inset: "",
  class: "inputGroup"
}
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "cell" }
const _hoisted_13 = {
  inset: "",
  class: "inputGroup"
}
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" <div class=\"close\" @click=\"onClose()\">\n            <van-icon class=\"icon\" size=\"14px\" name=\"cross\" />\n        </div> "),
    _createElementVNode("p", _hoisted_2, _toDisplayString($setup.t('通知')), 1 /* TEXT */),
    _createElementVNode("p", _hoisted_3, _toDisplayString($setup.t('平台即将移除手机号验证码登录方式，系统已自动为您生成账号，请补全其他信息，后续请使用账号密码登录！')), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_4, [
      _createCommentVNode(" 输入手机号，调起手机号键盘 "),
      _createElementVNode("p", _hoisted_5, _toDisplayString($setup.t("账号（不可更改）")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_van_field, {
          disabled: "",
          modelValue: $setup.account,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => (($setup.account) = $event)),
            $setup.checkText
          ],
          type: "text",
          placeholder: $setup.t('默认账号'),
          class: "input"
        }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createCommentVNode(" 密码 "),
      _createElementVNode("p", _hoisted_8, _toDisplayString($setup.t("设置密码")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_van_field, {
          maxlength: "30",
          modelValue: $setup.password,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
            $setup.checkText
          ],
          type: "password",
          clearable: "",
          placeholder: $setup.t('请输入密码'),
          class: "input"
        }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createCommentVNode(" 昵称 "),
      _createElementVNode("p", _hoisted_11, _toDisplayString($setup.t("me.username")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_van_field, {
          maxlength: "30",
          modelValue: $setup.nickname,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => (($setup.nickname) = $event)),
            $setup.checkText
          ],
          type: "text",
          placeholder: $setup.t('me.inputnickname'),
          class: "input"
        }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createCommentVNode(" 设置邮箱 "),
      _createElementVNode("p", _hoisted_14, _toDisplayString($setup.t("设置邮箱（用于找回密码，可选）")), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_van_field, {
          maxlength: "30",
          modelValue: $setup.email,
          "onUpdate:modelValue": [
            _cache[3] || (_cache[3] = ($event: any) => (($setup.email) = $event)),
            $setup.checkText
          ],
          type: "text",
          placeholder: $setup.t('请输入邮箱'),
          class: "input"
        }, null, 8 /* PROPS */, ["modelValue", "placeholder"])
      ])
    ]),
    _createElementVNode("div", {
      onClick: $setup.doRegister,
      class: "login_btn",
      block: ""
    }, _toDisplayString(_ctx.$t("me.ok")), 1 /* TEXT */)
  ]))
}